@if (absencePlannerService.plannerModel.members !== null) {
  <kendo-grid
    [kendoGridBinding]="members()"
    kendoGridSelectBy="id"
    size="medium"
    [selectable]="{ enabled: false }"
    [columnMenu]="false"
    id="planner"
    [resizable]="false"
    #grid
  >
    <ng-template kendoGridToolbarTemplate>
      <app-planner-control-bar
        [startOfMonth]="absencePlannerService.plannerModel.plannerStartOfMonth"
        [prev]="absencePlannerService.prev.bind(absencePlannerService)"
        [today]="absencePlannerService.today.bind(absencePlannerService)"
        [next]="absencePlannerService.next.bind(absencePlannerService)"
      >
        <h3 class="headline k-m-0" title-content>Abwesenheitsplaner</h3>
      </app-planner-control-bar>
    </ng-template>

    <kendo-grid-column
      field="member_name"
      [width]="plannerFixedColumnWidth"
      [class]="'cell-with-avatar'"
      [locked]="true"
      [autoSize]="false"
      [headerClass]="'member-name-header k-h-full'"
    >
      <ng-template kendoGridHeaderTemplate>
        <span class="k-font-weight-semibold">Mitarbeiter</span><span class="k-ml-1">(3)</span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-member>
        <div [attr.data-member-id]="member.id" [ngClass]="LockedMemberCellCSSClass">
          <div class="avatar-wrapper k-d-flex k-align-items-center k-h-full">
            <div class="k-d-inline-flex k-align-items-center">
              <app-shive-avatar [user]="member"></app-shive-avatar>
              <div class="member-name k-ml-3">{{ member | memberName }}</div>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-grid-column>

    @for (
      week of this.absencePlannerService.plannerModel.plannerWeeks;
      track $index;
      let lastWeek = $last
    ) {
      <kendo-grid-column
        field="week"
        [class]="'planner-week !k-pos-relative !k-overflow-visible'"
        [width]="plannerFixedColumnWidth"
        headerClass="!k-p-0"
      >
        <ng-template kendoGridHeaderTemplate>
          <div class="planner-selection-header k-d-flex k-flex-column k-flex-1">
            <div class="k-m-auto k-my-2">
              @if (week.days.length > 3) {
                <span>
                  <span class="k-font-weight-semibold"
                    >KW {{ String(week.weekNumber).padStart(2, "0") }} |</span
                  >
                  {{ week.startDate | date: "dd.MM" }}
                  -
                  {{ week.endDate | date: "dd.MM" }}
                </span>
              } @else {
                <span class="k-font-weight-semibold"
                  >KW {{ String(week.weekNumber).padStart(2, "0") }}
                </span>
              }
            </div>

            <div class="k-d-flex">
              @for (day of week.days; track $index; let lastDay = $last) {
                <div
                  class="header-days k-flex-1 k-pos-relative k-text-center"
                  [class.last-day-of-week]="lastDay"
                  [class.last-day-of-month]="lastWeek && lastDay"
                  [class.before-current-month]="
                    DateTimeHelper.isBefore(
                      day,
                      absencePlannerService.plannerModel.plannerStartOfMonth
                    )
                  "
                  [class.after-current-month]="
                    DateTimeHelper.isAfter(
                      day,
                      absencePlannerService.plannerModel.plannerEndOfMonth
                    )
                  "
                >
                  <div class="day-of-week">{{ day | date: "ccc" | uppercase }}</div>
                  <div class="k-mb-1.5 date-number">{{ day | date: "dd" }}</div>
                </div>
              }
            </div>
          </div>
        </ng-template>

        <ng-template kendoGridCellTemplate let-member>
          <div class="planner-selection-wrapper k-d-flex k-pos-relative">
            @for (day of week.days; track $index; let lastDay = $last) {
              <div
                class="planner-clickable-cell k-pos-relative k-w-full"
                [class.last-day-of-week]="lastDay"
                [class.last-day-of-month]="lastWeek && lastDay"
                [class.weekend]="DateTimeHelper.isWeekend(day)"
                [class.today]="DateTimeHelper.isToday(day)"
                [class.occupied-slot]="member | occupiedSlot: day : plannerEventModelsComputed()"
                #eventContainer
                appPlannerEventsContainer
                [date]="day"
                [member]="member"
              >
                <ng-container
                  appEventSlot
                  [member]="member"
                  [date]="day"
                  [eventContainer]="eventContainer"
                ></ng-container>

                <div class="add-new-indicator k-pos-absolute k-m-auto k-opacity-0">
                  <fa-icon size="xs" [icon]="faPlus"></fa-icon>
                </div>
              </div>
            }
          </div>
        </ng-template>
      </kendo-grid-column>
    }
  </kendo-grid>
}
